<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.invoice') }} > {{ $t('sidebar.all') }}
          </div>
        </div>
        <div class="col right">
          <div class="action">
            <div class="dropdown item">
              <button
                class="btn no-bg text-secondary dropdown-toggle filter"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false">
                <i class="fas fa-filter"/>
                {{ $t('message.filter') }}
                <template>
                  <span
                    v-if="query.status == 'all'"
                    class="badge badge-secondary">{{ $t('message.all') }}</span>
                  <span
                    v-if="query.status == 'padding'"
                    class="badge badge-warning">{{ $t('status.in.padding') }}</span>
                  <span
                    v-if="query.status == 'rejected'"
                    class="badge badge-danger">{{ $t('status.in.rejected') }}</span>
                  <span
                    v-if="query.status == 'uncompleted'"
                    class="badge badge-info">{{ $t('status.in.uncompleted') }}</span>
                  <span
                    v-if="query.status == 'completed'"
                    class="badge badge-success">{{ $t('status.in.completed') }}</span>
                </template>
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <form
                  class="px-3 py-2"
                  style="min-width: 300px;">
                  <div class="form-group mb-0">
                    <label>{{ $t('message.status') }}</label>
                    <select
                      v-model="query.status"
                      class="form-control form-control-sm">
                      <option value="all">{{ $t('message.all') }}</option>
                      <option
                        class="text-warning"
                        value="padding">
                        {{ $t('status.in.padding') }}
                      </option>
                      <option
                        class="text-danger"
                        value="rejected">
                        {{ $t('status.in.rejected') }}
                      </option>
                      <option
                        class="text-info"
                        value="uncompleted">
                        {{ $t('status.in.uncompleted') }}
                      </option>
                      <option
                        class="text-success"
                        value="completed">
                        {{ $t('status.in.completed') }}
                      </option>
                    </select>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <base-table
        v-else
        :pagination="$store.state.app.pagination"
        @onPageChange="handlePageChange"
      >
        <template #thead>
          <thead>
            <tr>
              <th style="min-width: 100px;">{{ $t('documents.in') }}</th>
              <th class="no-sort">{{ $t('message.reference') }}</th>
              <th class="no-sort">{{ $t('message.customer') }}</th>
              <th class="no-sort">{{ $t('message.productlist') }}</th>
              <th class="no-sort">{{ $t('documents.pe') }}</th>
              <th>{{ $t('message.debttotal') }}</th>
              <th>{{ $t('message.paidtotal') }}</th>
              <th>{{ $t('message.grandtotal') }}</th>
              <th>{{ $t('message.scheduled_at') }}</th>
              <th
                class="no-sort"
                style="max-width: 100px;">{{ $t('message.status') }}</th>
            </tr>
          </thead>
        </template>
        <template #tbody>
          <tbody>
            <tr>
              <td
                v-if="invoices.length === 0"
                colspan="9"
                class="text-center">
                {{ $t('message.notfounddata') }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in invoices"
              :key="index">
              <td :data-order="item.in_id">
                <router-link-custom
                  :to="{name: 'AccountsInvoiceEdit', query: {
                    in_id: item.in_id,
                    in_code: item.in_code
                  }}"
                  :text="item.in_code"
                  :to_appid="2"
                  :current_appid="12"/>
              </td>
              <td>
                <router-link-custom
                  v-if="item.reference.sale"
                  :to="{name: 'SaleOrderEdit', query: {
                    so_id: item.reference.sale.so_id,
                    so_code: item.reference.sale.so_code
                  }}"
                  :text="item.reference.sale.so_code"
                  :to_appid="5"
                  :current_appid="12"/>
              </td>
              <td>
                <router-link-custom
                  v-if="item.customer"
                  :to="{name: 'ContactCustomerEdit', query: {cus_id: item.customer.customer_id, cus_name: item.customer.customer_name}}"
                  :text="item.customer.customer_name"
                  :to_appid="11"
                  :current_appid="12"
                  :disabled="item.customer.is_deleted == true" />
              </td>
              <td>
                <item-list :orders="item.orders" />
              </td>
              <td style="vertical-align: top;">
                <div
                  v-for="(payment, index_) in item.reference.payments"
                  :key="index_"
                >
                  <router-link-custom
                    :to="{name: 'AccountsPaymentEntryEdit', query: {
                      pe_id: payment.pe_id,
                      pe_code: payment.pe_code
                    }}"
                    :text="payment.pe_code"
                    :status="{
                      text: getPaymentStatus(payment, $t).message,
                      color: getColorFormStatus(getPaymentStatus(payment, $t).status),
                      type: 'icon'
                    }"
                    :to_appid="12"
                    :current_appid="12"/>
                </div>
              </td>
              <td :data-order="getDebtInvoiceAmount(item)">
                {{ getNumber(getDebtInvoiceAmount(item)) }}
              </td>
              <td :data-order="getPaidAmount(item.reference.payments)">
                {{ getNumber(getPaidAmount(item.reference.payments)) }}
              </td>
              <td :data-order="getTotal(item.orders).payment">
                {{ getNumber(getTotal(item.orders).payment) }}
              </td>
              <td :data-order="item.scheduled_at">
                {{ getDate(item.scheduled_at) }}
              </td>
              <td style="max-width: 100px;">
                <template>
                  <span
                    v-if="getInvoiceStatus(item, $t, mixin).status == 'padding'"
                    class="text-warning">
                    {{ getInvoiceStatus(item, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getInvoiceStatus(item, $t, mixin).status == 'completed'"
                    class="text-success">
                    {{ getInvoiceStatus(item, $t, mixin).message }}
                  </span>
                  <span
                    v-else-if="getInvoiceStatus(item, $t, mixin).status == 'uncompleted'"
                    class="text-info">
                    {{ getInvoiceStatus(item, $t, mixin).message }}
                  </span>
                  <span
                    v-else
                    class="text-danger">
                    {{ getInvoiceStatus(item, $t, mixin).message }}
                  </span>
                </template>
              </td>
            </tr>
          </tbody>
        </template>
      </base-table>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'

export default {
  data () {
    return {
      ready: false,
      query: {
        page: this.$route.query.page || 1,
        status: this.$route.query.status || 'all',
      },
    }
  },
  computed: {
    ...mapGetters({
      invoices: 'getInvoices',
      getInvoiceStatus: 'getInvoiceStatus',
      getPaymentStatus: 'getPaymentStatus',
    }),
  },
  watch: {
    ready () {
      if (this.ready == true) {
        this.showFinish(this.$Progress)
      }
    },
    'query.status': {
      handler: function () {
        if ($('button.filter').parent().find('.dropdown-menu').attr('class').search('show') >= 0) {
          $('button.filter').dropdown('toggle')
        }
        this.fetchData()
      },
      deep: true,
    },
    $route (to, from) {
      if (!Object.keys(to.query).length) {
        this.query.page = 1
        this.query.status = 'all'
        this.fetchData()
      }
    },
  },
  created () {
    this.fetchData()
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.accounts.title'),
      current: {
        app_name: 'accounts',
        app_id: 12,
        module_id: 2,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
      submenuAtIdx: 0,
    })
  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearInvoices'])
  },
  methods: {
    async updateInvoiceStatus (data) {
      let res = await this.$store.dispatch('updateInvoiceStatus', { in_id: data.in_id, status: data.status })
      this.showFinish(this.$Progress)
    },
    async fetchData () {
      this.updateUrl()
      this.ready = false
      await this.$store.dispatch('getInvoices', {
        page: this.query.page,
        limit: this.$store.state.app.limitRowsPerpage,
        status: (() => {
          return this.query.status !== 'all'
            ? this.query.status
            : null
        })(),
      })
      this.ready = true
    },
    handlePageChange (pageNum = 1) {
      this.query.page = pageNum
      this.fetchData()
    },
    updateUrl () {
      const query = this.cleanObject(this.query)
      this.$router.push({ query }).catch(() => {})
    },
  },
}
</script>

<style scoped>
.dropdown > button {
    padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/accounts/invoice/All.vue